import type { Meta, StoryFn } from '@storybook/react';
import type { ActionListProps } from './ActionList';

import { ActionList } from './ActionList';

const codeString = `
  <ActionList iconName={iconName} variant={variant} label="">
    {mockActions.map(({ action, value }) => (
      <button type="button" onClick={() => onActionClick({ action, id })} key={value}> {action.title} </button>
    ))}
  </ActionList>
`;

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/ActionList',
  component: ActionList,
  argTypes: {
    variant: {
      options: ['primary', 'secondary', 'destructive-primary', 'destructive-secondary', 'blank', 'blank-icon'],
      control: { type: 'radio' },
    },
  },
  parameters: {
    inspectComponent: ActionList,
    codeString: codeString,
  },
} as Meta<ActionListProps>;

const Template: StoryFn<ActionListProps> = (args) => (
  <div style={{ marginLeft: '5rem', width: '40px' }}>
    <ActionList {...args} />
  </div>
);

const defaultArgs: Partial<ActionListProps> = {
  label: '',
  variant: 'blank-icon',
  iconName: 'EllipsisVertical',
  children: [
    <button key="1" type="button">
      Action 1
    </button>,
    <button key="2" type="button">
      Action 2
    </button>,
    <button key="3" type="button">
      Action 3
    </button>,
  ],
};

export const ActionListExample = Template.bind({});
ActionListExample.args = {
  ...defaultArgs,
};
